var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height bg-studio"},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{attrs:{"baseRoute":_vm.baseRoute,"search":_vm.search}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }